import { NavigateFunction } from 'react-router-dom';

import SocketService from '@src/services/SocketService';

import { EWebinarRoutes, EWebinarSockets } from '@src/constants';

export const handleExitOrEndWebinar = async ({
  endSessionForAll = false,
  redirect,
  roomType = 'webinar',
  sendEvent = true,
  path = EWebinarRoutes.END,
}: {
  endSessionForAll?: boolean;
  redirect?: NavigateFunction;
  roomType?: string;
  sendEvent?: boolean;
  path?: EWebinarRoutes;
}) => {
  const isWebinar = roomType === 'webinar';
  const qs = new URLSearchParams(window.location.search);
  const currentRoomId = qs.get(isWebinar ? 'wid' : 'room');

  if (currentRoomId) {
    localStorage.setItem('lastRoom', currentRoomId);
  }

  if (endSessionForAll) {
    sendEvent && (await SocketService.request(EWebinarSockets.END_WEBINAR));
    redirect?.(path ?? EWebinarRoutes.END, { state: { roomType }, replace: true });
    localStorage.removeItem('lastRoom');
  } else {
    sendEvent && (await SocketService.request(EWebinarSockets.EXIT_ROOM));
    redirect?.(path ?? EWebinarRoutes.REJOIN, { state: { roomType }, replace: true });
  }
};
